module.exports = __webpack_public_path__ + "static/media/aauxnext-md.0de3bc4a.woff2";